const jwt = require('jsonwebtoken');

const getProfile = () => {
    const tokens = JSON.parse(localStorage.getItem('user')) || null;
    if (!tokens) {
        return {
            email: '',
            firstName: '',
            lastName: '',
            isAdmin: false,
            loggedIn: false
        }
    } else {
        const { payload } = jwt.decode(tokens['idToken'], { complete: true })
        return {
            email: payload['cognito:username'],
            firstName: payload['custom:firstname'],
            lastName: payload['custom:lastname'],
            isAdmin: payload['custom:role'] === 'ADMIN',
            loggedIn: true
        }
    }
}

module.exports = {
    getProfile
}